module.exports = __webpack_public_path__ + "img/pe.041464ff.svg";